import React from 'react'
import { Registry } from '@react-registry'
import { useSelected, useFocused } from 'slate-react'
import styles from './style.module.css'
import { cx } from '@emotion/css'
import { cloneDeep } from 'lodash'

const Video = (props) => {
  const selected = useSelected()
  const focused = useFocused()

  const { element } = props;

  const videoRedactorAttributes = cloneDeep(element?.attrs?.['redactor-attributes']) ?? {}

  Object.keys(videoRedactorAttributes)?.forEach((attrKey) => {
    if (videoRedactorAttributes[attrKey] === '') {
      videoRedactorAttributes[attrKey] = true
    }
  })

  if (!videoRedactorAttributes.width) {
    videoRedactorAttributes.width = "100%"
  }

  return (
    <div {...props.attributes}>
      <video
        {...videoRedactorAttributes}
        className={cx(styles['scrte-video'], {
          [styles['scrte--video-selected']]: selected && focused
        })}>
        {element.attrs?.sourceRedactorAttributes?.length > 0 ? (
          <>
            {element.attrs?.sourceRedactorAttributes.map((sourceAttributes) => (
              <source {...sourceAttributes} />
            ))}
          </>
        ) : null}
      </video>
      {props.children}
    </div>
  )
}

export default Video
export * from './deserializer'
export * from './withVideo'

Registry.register(
  {
    Component: Video
  },
  { id: 'video', registry: 'element' }
)
